import { TimeframeService } from "services/TimeframeService";

export const TIMESERIES_OPTIONS_TEMPLATE = {
  options: {
    timeframe: {
      start: null,
      type: null,
      "length.units": null,
      "length.value": null,
    },
    timezone: null,
  },
};

const useTimeSeriesWithTimeRangeExplorer = ({
  optionsProxy,
  updateOptionsProxy,
  setTimeframe,
  startTime,
  endTime,
  maxWindowInSeconds,
}) => {
  const { timeframe = {}, timezone } = optionsProxy?.options ?? {};

  const showPrevious = () => {
    setTimeframe(
      TimeframeService.getPreviousTimeframe(
        timeframe,
        startTime,
        maxWindowInSeconds
      )
    );
  };

  const showNext = () => {
    setTimeframe(
      TimeframeService.getNextTimeframe(
        timeframe,
        startTime,
        maxWindowInSeconds
      )
    );
  };

  const setOptions = (options) => {
    // map explorer options to widget options
    const periodsToShow = options.periodsToShow;
    const timerange = options.timerange;
    const timeframeType = options.timeframeType;
    const startDate = options.startDate;
    const timeframeUpdates = {};
    if (periodsToShow) {
      timeframeUpdates["length.value"] = periodsToShow;
    }
    if (timerange) {
      timeframeUpdates["length.units"] = `${timerange}s`;
    }
    if (timeframeType) {
      timeframeUpdates.type = timeframeType;
    }
    if (startDate) {
      timeframeUpdates.start = startDate;
    }
    updateOptionsProxy(
      {
        options: {
          ...optionsProxy.options,
          timeframe: { ...timeframe, ...timeframeUpdates },
        },
      }
    );
  };

  const getNormalizedTimerange = () => {
    const timerange = timeframe["length.units"] ?? "";
    return timerange.slice(0, -1);
  };

  return {
    options: {
      periodsToShow: timeframe["length.value"],
      timerange: getNormalizedTimerange(),
      timeframeType: timeframe.type,
      startDate: startTime?.valueOf(),
      endDate: endTime?.valueOf(),
      timezone: timezone,
    },
    timerangesSupported: ["minute","hour", "day"],
    setOptions,
    showPrevious,
    showNext,
  };
};

export default useTimeSeriesWithTimeRangeExplorer;
